import queryString from 'query-string'
import FontAwesome from 'react-fontawesome'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Button = styled.button`
  background: none;
  border: none;
  margin-top: 10px;
`

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
`

const Iframe = styled.iframe`
  flex-grow: 1;
`

const addShowHeaderFalseToUrl = (url) => {
  const parsed = queryString.parseUrl(url)
  const newQuery = { ...parsed.query, showHeader: 'false' }

  return `${parsed.url}?${queryString.stringify(newQuery)}`
}

const Preview = ({ url, close }) => {
  if (!url) {
    return null
  }
  const newUrl = addShowHeaderFalseToUrl(url)

  return (
    <Wrapper>
      <div className="clearfix">
        <h4 className="pull-left">Preview</h4>
        <Button
          className="pull-right"
          type="button"
          onClick={close}
          title="Close Preview"
        >
          <FontAwesome name="times" />
        </Button>
      </div>
      <Iframe frameBorder="0" src={newUrl} />
    </Wrapper>
  )
}

Preview.propTypes = {
  url: PropTypes.string,
  close: PropTypes.func.isRequired
}

export default Preview
